import { Text, View } from "@react-pdf/renderer";
import { PDFTableColumn } from "components/PDF/Table";
import { EntradaAcordo } from "core/features/acordo/typings";
import { formatMoney } from "infra/helpers/number";
import { useMemo } from "react";

function useEntradaAcordoPdfColumns(): PDFTableColumn<EntradaAcordo>[] {
  return useMemo(() => {
    const columns: PDFTableColumn<EntradaAcordo>[] = [];

    columns.push({
      title: "Valor",
      flexGrow: 0.6,
      render: (original) => (
        <View>
          <Text>{formatMoney(original.valor)}</Text>
        </View>
      ),
    });

    columns.push({
      title: "Forma de pagamento",
      flexGrow: 0.8,
      textAlign: "right",
      render: (original) => (
        <View>
          <Text>{original.formaPagamento.nome}</Text>
        </View>
      ),
    });

    return columns;
  }, []);
}

export default useEntradaAcordoPdfColumns;
